<template>
  <div class="special-list" v-if="dataList.length!=0">
    <div :key="item.id" class="special-box" v-for="(item, index) in dataList">
      <div class="special-box-image">
        <el-image :preview-src-list="viewShow[index]" :src="item.coverPicture=='/'?require('../../assets/image/index/swich_banner.png'):item.coverPicture.split(',')[0]" fit="fill"></el-image>
      </div>
      <div class="special-box-text">
        <div class="text-header">
          <div class="header-category">图片</div>
          <div class="header-title">{{item.title}}</div>
        </div>
        <div class="row-bg">
          <div class="text-brief" v-show="item.classification">
            <span class="item-explain">类别</span>:
            <span class="item-content">{{item.classification}}</span>
          </div>
          <div class="text-brief" v-show="item.introduction">
            <span class="item-explain">简介</span>:
            <span class="item-content">
                            {{item.introduction}}
              <!-- 《顿造忙(创世经)》为壮语南部方言民间信仰经典，在形式上是以殡葬礼仪来谈论创世的故事，其内容主要反映壮族及其先民对开天辟地、人类繁行、开垦拓围、筑城建州、土官分封、领主制度、生息企求等的认知思维及生活理念，展现想象中的世界图式，折射壮族地区社会发展的历史印迹;融神话、故事、歌谣、祭词等于一体，充满浓厚的壮乡生活气息和南国边疆文化色彩，对研究我国南方民族迁徙史、土司制度兴嘉史、民族文化交流史及壮族方 -->
                        </span>
          </div>
          <div class="text-brief" v-show="item.author">
            <span class="item-explain">作者</span>:
            <span class="item-content">
              {{item.author}}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PortalIndex',
    props: {
      dataList: {
        type: Array,
        required: true,
        default: () => []
      }
    },
    data() {
      return {
      };
    },
    created() {
      this.init()

    },
    mounted() {

    },

    methods: {
      init() {
        this.viewShow = []
        this.dataList.forEach(e => {
          let arr = []
          e.coverPicture.split(',').forEach(item => {
            arr.push(item.replace('small.jpg', 'large.jpg'))
          })
          if(arr[0]=='/'){
            arr=[]
          }
          this.viewShow.push(arr)
        })
      }
    },
    watch: {
      dataList: {
        handler: function (news, old) {
          this.init()
        },
        deep: true
      }
    },
  };
</script>

<style lang="less" scoped>
  .special-list {
    .special-box {
      width: 47.188rem;
      min-height: 11.563rem;
      border: 1px solid #e8e8e8;
      margin-bottom: 1.042rem;
      display: flex;
      padding-left: 2.188rem;
      padding-right: 1.188rem;
      padding-top: 1.198rem;
      padding-bottom: 1.094rem;

      .special-box-image {
        margin-right: 1.042rem;

        .el-image {
          width: 11.979rem;
          height: 9.271rem
        }
      }
    }

    .special-box:last-child {
      margin-bottom: 0px;
    }

    .special-box-text {
      position: relative;

      .text-header {
        display: flex;
        align-items: center;
        margin-bottom: 0.833rem;

        .header-category {
          width: auto;
          height: 1.342rem;
          line-height: 1.342rem;
          background-color: #aa6c39;
          border-radius: 7px;
          color: #fff;
          padding: 0 0.3rem;
          font-size: 0.8rem;
          margin-right: 0.26rem;
        }
      }

      .row-bg {
        font-size: 0.725rem;
        min-height: 7rem;
        margin-bottom: 0.5rem;
        line-height: 1.8;

        .text-brief {
          .item-explain {
            width: 4em;
            color: #ccc;
            display: inline-block;
            text-align-last: justify;
          }
        }
      }
    }

  }
</style>
